import React from 'react';
import { TopBar } from '@/components/TopBar';
import { Page } from '@/components/Page';
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { fmtDate } from '@/lib/helpers';

export default function Audit() {
  const { data: logs = [] } = useQuery({ queryKey: ['audit'], queryFn: async () => (await api.get('/audit')).data.data });
  return (
    <Page>
      <TopBar title="Audit Log" showStore={false} />
      <div className="px-4 pt-4 space-y-2">
        {logs.length === 0 ? <p className="py-10 text-center text-sm text-muted-foreground">No audit entries.</p> :
          logs.map((l) => (
            <div key={l.id} className="rounded-xl border border-border bg-card p-3" data-testid={`audit-${l.id}`}>
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold">{l.action.replace(/_/g, ' ')}</p>
                <p className="text-xs text-muted-foreground">{fmtDate(l.ts)}</p>
              </div>
              <p className="font-mono text-xs text-muted-foreground">{l.user} · {l.ref_type} · {l.ref_id?.slice(0, 8)}</p>
            </div>
          ))}
      </div>
    </Page>
  );
}
